import React from "react";
import { IntlProvider } from "react-intl";
import { Route, Switch } from "react-router-dom";

import {
  normalizeContentServiceResponse,
  getDomainCookie,
  setDomainCookie
} from "@sincro/react-global-header-and-navigation";
import { PageSpinner } from "@sincro/react-page-spinner";

import { makeRequest } from "./shared/services/ApiHandler";
import { getNormalizedLocale, hyphenateLocale } from "./shared/services/utils";
import {
  getAppServiceApiUrl,
  getLoginServiceApiUrl
} from "./shared/services/AppService";
import App from "./views/App";

export class AppContainer extends React.Component {
  messages = {
    "en-US": require("./i18n/en-US.json"),
    "en-CA": require("./i18n/en-CA.json"),
    "fr-CA": require("./i18n/fr-CA.json"),
    "es-US": require("./i18n/es-US.json")
  };
  constructor(props) {
    super(props);

    this.state = {
      announcements: [],
      locale: hyphenateLocale(this.getStoredUserLocale()),
      isAuthenticated: false,
      notifications: [],
      showLoader: true,
      apps: []
    };
  }
  getStoredUserLocale = () => {
    const cookieValue = getDomainCookie();

    return (cookieValue && cookieValue.userLocale) || "en-US";
  };
  updateLocale = locale => {
    if (locale !== this.state.locale) {
      const currentLocale = this.messages[locale] ? locale : "en-US";
      this.setState({
        locale: currentLocale
      });
      setDomainCookie(this.updateCookieValue(currentLocale));
      this.getDccApps(currentLocale);
    }
  };
  updateCookieValue = locale => {
    let updatedObj = getDomainCookie() || {};

    updatedObj.userLocale = getNormalizedLocale(locale);

    return updatedObj;
  };
  getDccApps = locale => {
    const appServiceUrl = getAppServiceApiUrl();
    const normalizedLocale = getNormalizedLocale(locale);
    const url = `${appServiceUrl}?userLocale=${normalizedLocale}`;
    this.getAppDetails(url);
  };
  getAppDetails = url => {
    this.setState({
      showLoader: true
    });
    makeRequest(url)
      .then(res => {
        if (res) {
          const apps = this.filterResponse(res);
          const announcements = normalizeContentServiceResponse(
            res,
            "announcement"
          );
          const notifications = normalizeContentServiceResponse(res);
          this.setState({
            announcements: announcements,
            apps: apps,
            isAuthenticated: true,
            notifications: notifications,
            showLoader: false
          });
        }
      })
      .catch(err => {
        if (err) {
          if (err.response && err.response.status === 401) {
            window.location = getLoginServiceApiUrl();
          }
          this.setState({
            isAuthenticated: false,
            showLoader: false
          });
        }
      });
  };
  filterResponse = apps => {
    return apps.filter(app => app.code !== "DCC");
  };
  componentDidMount() {
    this.getDccApps(this.state.locale);
  }
  render() {
    const {
      announcements,
      apps,
      isAuthenticated,
      locale,
      notifications,
      showLoader
    } = this.state;
    return (
      <IntlProvider locale={locale} messages={this.messages[locale]}>
        <PageSpinner show={showLoader} />
        <Switch>
          <Route
            path="/"
            render={props => (
              <App
                {...props}
                announcements={announcements}
                notifications={notifications}
                apps={apps}
                isAuthenticated={isAuthenticated}
                locale={locale}
                updateLocale={this.updateLocale}
              />
            )}
          />
        </Switch>
      </IntlProvider>
    );
  }
}

export default AppContainer;
